"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureColumnTemplate = exports.columnAttributeTemplate = exports.rowAttributeTemplate = void 0;
var tslib_1 = require("tslib");
var colDefHeaderClass_1 = require("./colDefHeaderClass");
var constants_1 = require("../base/constants");
var cellUtils_1 = require("../cell/cellUtils");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ts_invariant_1 = require("ts-invariant");
var tableDescriptorTypes_1 = require("./tableDescriptorTypes");
var cellClass_1 = require("../cell/cellClass");
var cellRenderer_1 = require("../cell/cellRenderer");
function rowAttributeTemplate(table, props) {
    var cellRenderer = cellRenderer_1.createCellRenderer();
    return {
        cellClass: cellClass_1.cellClassFactory(table, props, "gd-row-attribute-column"),
        headerClass: colDefHeaderClass_1.headerClassFactory(table, props, "gd-row-attribute-column-header"),
        colSpan: function (params) {
            if (
            // params.data is undefined when rows are in loading state
            params.data &&
                params.data.colSpan &&
                constants_1.AVAILABLE_TOTALS.find(function (item) { return item === params.data[params.data.colSpan.headerKey]; })) {
                return params.data.colSpan.count;
            }
            return 1;
        },
        valueFormatter: function (params) {
            return params.value === undefined ? null : params.value;
        },
        cellRenderer: cellRenderer,
    };
}
exports.rowAttributeTemplate = rowAttributeTemplate;
function columnAttributeTemplate(table, props) {
    return {
        cellClass: cellClass_1.cellClassFactory(table, props, "gd-column-attribute-column"),
        headerClass: colDefHeaderClass_1.headerClassFactory(table, props, "gd-column-attribute-column-header"),
    };
}
exports.columnAttributeTemplate = columnAttributeTemplate;
var AG_NUMERIC_CELL_CLASSNAME = "ag-numeric-cell";
var AG_NUMERIC_HEADER_CLASSNAME = "ag-numeric-header";
function measureColumnTemplate(table, props) {
    var _a;
    var cellRenderer = cellRenderer_1.createCellRenderer();
    var separators = (_a = props.config) === null || _a === void 0 ? void 0 : _a.separators;
    return {
        cellClass: cellClass_1.cellClassFactory(table, props, classnames_1.default(AG_NUMERIC_CELL_CLASSNAME, "gd-measure-column")),
        headerClass: colDefHeaderClass_1.headerClassFactory(table, props, classnames_1.default(AG_NUMERIC_HEADER_CLASSNAME, "gd-measure-column-header")),
        // wrong params type from ag-grid, we need any
        valueFormatter: function (params) {
            var colDesc = table.tableDescriptor.getCol(params.colDef);
            ts_invariant_1.invariant(tableDescriptorTypes_1.isSeriesCol(colDesc));
            return params.value !== undefined
                ? cellUtils_1.getMeasureCellFormattedValue(params.value, colDesc.seriesDescriptor.measureFormat(), separators)
                : null;
        },
        cellStyle: function (params) {
            var colDesc = table.tableDescriptor.getCol(params.colDef);
            ts_invariant_1.invariant(tableDescriptorTypes_1.isSeriesCol(colDesc));
            return params.value !== undefined
                ? cellUtils_1.getMeasureCellStyle(params.value, colDesc.seriesDescriptor.measureFormat(), separators, true)
                : null;
        },
        cellRenderer: cellRenderer,
    };
}
exports.measureColumnTemplate = measureColumnTemplate;
//# sourceMappingURL=colDefTemplates.js.map